import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { essences } from 'src/app/services/appmeta';
import { PileRow } from 'src/app/services/report.service';

@Component({
  selector: 'app-report-cell-editor',
  templateUrl: './report-cell-editor.page.html',
  styleUrls: ['./report-cell-editor.page.scss'],
})
export class ReportCellEditorPage implements OnInit {
  @Input() item:PileRow;
  logLengths:string[] = [8,9,10,16,17,18, 21].map( n=>String(n));
  essenceCodes:string[] = essences.map( e=>e.code);
  newValues:any={};
  hasChanges:boolean;
  // get value(){
  //   return this.item && this.prop ? this.item[this.prop] : null;
  // }

  logLengthChanged(newLength){

    if(newLength == this.item['ATTRIBUTE8'].value){
      delete this.newValues['ATTRIBUTE8'];
    }else{
      this.newValues['ATTRIBUTE8']=newLength;
    }
  }
  essenceCodeChanged(newCode){
    let nameIndex = essences.findIndex( e=>e.code == newCode );
    if(newCode == this.item['ATTRIBUTE5'].value){
        delete this.newValues['ATTRIBUTE5'];
    }else{
      this.newValues['ATTRIBUTE5']=essences[nameIndex];
    }
  }
  heightChanged(newHeight){
    if(newHeight == this.item['ATTRIBUTE9'].value){
      delete this.newValues['ATTRIBUTE9'];
    }else{
      this.newValues['ATTRIBUTE9']=newHeight;
    }
  }
  lengthChanged(newLength){
    if(newLength == this.item['ATTRIBUTE10'].value){
      delete this.newValues['ATTRIBUTE10'];
    }else{
      this.newValues['ATTRIBUTE10']=newLength;
    }
  }
  errorProps:string[]=[];
  errorMap: {};

  constructor(public modal:ModalController) {
  }

  ngOnInit() {
    let map = {};
    this.item['ERRORS'].details.forEach( ( errorDetail:any )=>{
      const {keys,message} = errorDetail;
      keys.forEach( ( k )=>{
        if(!map[k]){
          map[k]=[];
        }
        map[k].push(message);
      });
    })
    this.errorProps = Object.keys(map);
    this.errorMap = map;
    // console.log({item:this.item})
  }
  dismiss(){
    this.modal.dismiss();
  }
  save(){
   let hasChanged = Object.keys(this.newValues).length > 0;
   if(hasChanged){
     this.modal.dismiss(this.newValues);
   }else{
     this.modal.dismiss();
   }

  }

}
